module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('p', {
    staticClass: "SP",
    attrs: {
      "id": "ch2"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "CN"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_3",
      "title": "3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_ch2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ePub-B"
  }, [_vm._v("KATE")])])])]), _vm._v(" "), _c('p', {
    staticClass: "CO"
  }, [_vm._v("Sam Grist sits across from me, staring. His eyes are so piercing that for a moment I’m paralyzed.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I’m not oblivious. I’ve noticed him watching me in class. I’ve observed the way his gaze follows me, tracing the lines of my body like he’s committing them to memory. Sometimes he wears a vaguely drunk expression, like someone two martinis into the evening watching you from across the bar—when you know you’re caught in a glimmering vodka filter that makes everything luminous.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("This is the first time I’ve been alone with him. The air in my small office feels thick, dense. His eyes lock on mine with such unapologetic intensity, for a second I can’t remember how to breathe. When one of my students uses the term “piercing” to describe someone’s bright blue eyes, I usually scribble “clich"), _c('span', {
    staticClass: "accent"
  }, [_vm._v("é")]), _vm._v("” in the margin. Now, I’m forced to acknowledge just how apt the phrase can be. His stare pins me to my seat.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("With effort, I look away. That’s hardly better. My eyes sink as low as his throat. The skin there is that delicate peach color only youth can manage. So dewy. So tender. If I put my lips there—"), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("goddamn it. Stop, Kate. Just stop.")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Nabokov’s my favorite. "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Lolita.")]), _vm._v(" What a fucking beautiful book—sorry.” He blushes, his pale cheeks turning pink.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_4",
      "title": "4"
    }
  }, [_vm._v("“It’s okay.” I adjust my glasses. “I’m a professor, not a preacher. I’m more offended by comma splices than ‘fuck.’”")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("The word lingers in the air between us. It’s there, like the traces a sparkler leaves behind, glimmering in the muted light of my office.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I glance at the floor lamp behind him. Its pale linen shade casts a soft glow. When I bought the lamp last week I told myself I needed it so I could kill the fluorescents in my tiny office; they were giving me a headache. I’ve never liked the cold, clinical mood they radiate. Now, though, I wonder if the vibe is too ‘candlelit lounge.’ It’s something I do way too often, swing from one extreme to another—in this case, from morgue to topless bar.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("His smile is slow and knowing as he watches me. Now his eyes dip to my cleavage, and I worry I’ve gone too far. Low lights, “fuck,” "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("Lolita")]), _vm._v(". This is not the professorial persona my tenure team needs to see.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I clear my throat, and his smile vanishes.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“So, you have a question about class?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("He leans back. The glow from the lamp catches in his dark black hair. I try to look at him coolly. I try to channel all the bloodless, sexless professors I’ve ever had. The incredibly well-shaped muscles beneath his black T-shirt beckon from my peripheral vision, but I refuse to give in. "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("It’s the divorce,")]), _vm._v(" I tell myself. "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("You’re hungry for distraction. Go easy on yourself.")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“I do.” He nods. “Is it a good time?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Shoot.” I glance quickly at my computer, then back at him. We don’t have all day, but I can carve out some time from my frantic online shoe shopping to deal with his needs. It’s important to prioritize.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“It’s about the workshop.” He rests his arms on my desk, waiting for me to meet his gaze directly before he goes on. “There’s some really god-awful shit in there, you know?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I watch him as he catches himself swearing again, see him de"), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_5",
      "title": "5"
    }
  }, [_vm._v("cide against apologizing. He’s young, but not as young as some of my students. Twenty, maybe? Twenty-one? It’s nearly impossible to guess at age anymore. I’ve given up, especially during that breathless time between eighteen and twenty-five, seven years that feel like they’ll last forever, when you wear the face and body of an adult but still have the blank, unmarked dewiness of a child.")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“It’s Sam, right?” I take off my glasses and clean them with the hem of my sweater.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Yeah. Sam.” There’s a subtle reproach in his voice, like he’s disappointed I had to ask.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I didn’t have to. I just need him to know I don’t think about him. I haven’t singled him out. The fact that this is a lie makes it even more important.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Are you asking if I think my students’ work is shit?”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“I know you think it’s shit.” He tilts his head to the side. He’s peering past my fa"), _c('span', {
    staticClass: "accent"
  }, [_vm._v("ç")]), _vm._v("ade, into me. “I’m asking why you don’t call them on it.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I pull my cardigan tighter and put my glasses back on. “‘Shit’ is a relative term.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Either it sucks or it doesn’t.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Nabokov had a hell of a time getting published,” I point out.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Not because publishers thought his work was shit. Because he terrified them.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I nod, conceding his point, and change tack. “Workshop is all about getting better. New writers need to experiment.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“You and I both know those spoiled brats are never going to write a single word worth reading.” His cynical smile makes me uneasy.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I’ve got no idea why Sam affects me the way he does. It’s not like he’s the first smug, talented student ever to sit in that seat lobbing overly confident truisms about workshop at me. And yet … and "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("yet")]), _vm._v(" … there’s something about this one. The way his eyes probe my face, the restless motion of his body. He keeps leaning back, like "), _c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pg_6",
      "title": "6"
    }
  }, [_vm._v("an actor trying to telegraph “relaxed.” Within seconds, though, his sculpted torso tips forward again, his naked forearms on my desk, his body straining toward me.")])]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“I don’t know that.” I can hear the crispness in my tone, the prim, professorial inflection. “Nobody knows what anyone else is capable of.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Now "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("that")]), _vm._v(" I believe.” He points at me, like he’s the teacher and I’m the student finally stumbling on the right answer.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("I kind of hate him. I kind of want him.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("His big, beautiful hands land on my desk again; for just a second, his palms lie faceup between us. I see the jagged scars carved into his wrists, red, angry lightning bolts zigzagging his blue veins. My gaze flies to his face. He knows I’ve noticed. His eyes hold mine. In that moment, I’m certain he wanted me to see. But then he pulls his hands back, presses them against his thighs, and stands.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“I won’t take up any more of your valuable time.” His gaze flicks to my computer screen. I must have accidentally jiggled the mouse because Zappos is now perfectly visible.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("It’s my turn to blush. Goddamn him.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“Don’t be so harsh on your fellow writers.” I try to sound sage, like someone who lives profoundly, someone who has actual wisdom to pass on. “If you’re right, and they’re all hacks, that’s good news, right? Less competition.”")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("He raises an eyebrow. I’ve always wanted to master that move but could never seem to manage it. When I try, it comes off strained and frightened. He pulls it off so naturally, like he came out of his mother’s womb and fixed her with that sardonic stare.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("“I’m not worried about competition.” He twists the doorknob.")]), _vm._v(" "), _c('p', {
    staticClass: "TX"
  }, [_vm._v("My eyes dart to his wrist, seeking out the pink, puckered wound. I force myself to dismiss him with a nod, like someone who knows what the hell she’s doing.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22ac7106","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter2.vue
// module id = 75
// module chunks = 0